module.exports = __webpack_public_path__ + "static/media/CASSI.4f5696f7.svg";